import axios from 'axios';
import config from '@/utils/config';

const instance = axios.create({
  baseURL: config.get('pdfServiceApi'),
});

export type TGenerateBookingHtmlParams = {
  booking_date: string;
  first_name: string;
  last_name: string;
  patronymic: string;
  email: string;
  phone: string;
  vehicle_color: string;
  vehicle_price: string;
};

export type TGenerateBookingHtmlResponse = string;

export function generateBookingHtml(params: TGenerateBookingHtmlParams) {
  return instance.get<TGenerateBookingHtmlResponse>(`/html/booking-contract`, { params });
}

export default instance;
